export default class UrlHelper {
    /**
     * The URL requested, before initial routing.
     */
    static initialUrl = location.href;

    static getQueryParameters() {
        return document.location.search.replace(/(^\?)/, '').split("&").map(function (n) { return n = n.split("="), this[n[0]] = n[1], this }.bind({}))[0];
    }
}


// WEBPACK FOOTER //
// ./src/shared/libs/ClientFramework/packages/abpVue/helpers/UrlHelper.js